const markSelectOptions = options => options.map(option => {
  if (!option.discarded)
    return { value: option.id, label: option.content }

  return { value: option.id, label: `${option.content} (supprimée)`, isDisabled: true }
})

export default markSelectOptions
